import RecommendationInfo from "../components/environmental/RecommendationInfo";
import {Link} from 'react-router-dom';
import moment from 'moment';
import { Tag } from 'antd';

export const Data = [
    {
        id: 1,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'Greece',
        product: 'Oranges',
        date: '2024-01-28',
        title: 'Test',
        status: 'Certified'
    },
    {
        id: 2,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'Serbia',
        product: 'Oranges',
        date: '2024-01-28',
        title: 'Test 2',
        status: 'Certified'
    },
    {
        id: 3,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'Serbia',
        product: 'Apples',
        date: '2024-04-12',
        title: 'Test 3',
        status: 'Pending'
    },
    {
        id: 4,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'Serbia',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 4',
        status: 'Verified'
    },
    {
        id: 5,
        lotNumber: 'lucy',
        organization: 'lucy',
        region: 'Serbia',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 5',
        status: 'Pending'
    },
    {
        id: 6,
        lotNumber: 'lucy',
        organization: 'lucy',
        region: 'Greece',
        product: 'Apples',
        date: '2024-04-12',
        title: 'Test 6',
        status: 'Verified'
    },
    {
        id: 7,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'Greece',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 7',
        status: 'Verified'
    }
]


export const complianceData = [
    {
        id: 1,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'bionet',
        product: 'Oranges',
        date: '2024-01-28',
        title: 'Test',
        status: 'certification'
    },
    {
        id: 2,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'univer',
        product: 'Oranges',
        date: '2024-01-28',
        title: 'Test 2',
        status: 'certification'
    },
    {
        id: 3,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'univer',
        product: 'Apples',
        date: '2024-04-12',
        title: 'Test 3',
        status: 'verification'
    },
    {
        id: 4,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'univer',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 4',
        status: 'verification'
    },
    {
        id: 5,
        lotNumber: 'lucy',
        organization: 'lucy',
        region: 'univer',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 5',
        status: 'verification'
    },
    {
        id: 6,
        lotNumber: 'lucy',
        organization: 'lucy',
        region: 'bionet',
        product: 'Apples',
        date: '2024-04-12',
        title: 'Test 6',
        status: 'verification'
    },
    {
        id: 7,
        lotNumber: 'bio-net',
        organization: 'bio-net',
        region: 'bionet',
        product: 'Oranges',
        date: '2024-04-12',
        title: 'Test 7',
        status: 'verification'
    }
]


export const getRecommendation = (key, value) => {
    switch (key.toLowerCase()) {
        case 'ph':
            if (value < 5.5) {
                return {
                    ribbon: 'Acitic',
                    content: <RecommendationInfo optimalRange="6.0 - 7.0" recommendation="Apply lime on pH deviation" explanation="pH affects nutrient availability and microbial health" />
                };
            }
            if (value > 7.5) {
                return {
                    ribbon: 'Alkaline',
                    content: <RecommendationInfo optimalRange="6.0 - 7.0" recommendation="Sulfur depending on pH deviation" explanation="pH affects nutrient availability and microbial health" />
                };
            }
            return null;
        case 'tn':
            if (value < 0.1) {
                return {
                    ribbon: 'Deficient',
                    content: <RecommendationInfo optimalRange="0.1% - 0.3%" recommendation="Use legumes, compost, or green manure" explanation="Essential for plant growth and productivity" />
                };
            }
            return null;
         case 'soc':
            if (value < 1) {
                return {
                    ribbon: 'Depleted',
                    content: <RecommendationInfo optimalRange=">2%" recommendation="Apply compost, biochar, use cover crops" explanation="SOC enhances fertility, water retention, and carbon storage" />
                };
            }
            return null;
         case 'clay':
            if (value > 30) {
                return {
                    ribbon: 'Poor Drainage',
                    content: <RecommendationInfo optimalRange="10% - 30%" recommendation="Amend with gypsum; for sandy soils, add organic matter" explanation="Affects water retention and tillage practices" />
                };
            }
            return null;
         case 'purity index':
            if (value < 0.8) {
                return {
                    ribbon: 'High Contamination',
                    content: <RecommendationInfo optimalRange="0.9 - 1.0" recommendation="Verify with lab; apply organic remediation" explanation="Indicates contamination or adulteration, supporting organic compliance checks" />
                };
            }
            return null;
        default:
            return null;
    }
};

const StatusTag = ({ status }) => {
  const getStatusConfig = (status) => {
    const statusLower = status?.toLowerCase();
    
    switch (statusLower) {
      case 'certified':
      case 'verified':
      case 'completed':
      case 'active':
        return { color: 'green', text: status };
      case 'pending':
      case 'processing':
        return { color: 'orange', text: status };
      case 'failed':
      case 'rejected':
      case 'inactive':
        return { color: 'red', text: status };
      default:
        return { color: 'blue', text: status || 'Unknown' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Tag color={config.color}>
      {config.text}
    </Tag>
  );
};


export const SupplyChainTrackingCols = [
    {
        title: 'Lot Number',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        render: (text, record) => (
            <Link to={{ 
                pathname: `/supply-chain-tracking-results/${record._id}`,
                state: { asset: record }
            }}>
                {text}
            </Link>
        ),
    },
    {
        title: 'GTIN',
        dataIndex: 'GTIN',
        key: 'GTIN',
        render: (text) => text || 'N/A',
    },
    {
        title: 'Producer',
        dataIndex: 'producerName',
        key: 'producerName',
        render: (text) => text || 'N/A',
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (text, record) => 
            text !== null ? `${text} ${record.uom || ''}` : 'N/A',
    },
    {
        title: 'Production Date',
        dataIndex: 'productionDate',
        key: 'productionDate',
        render: (text) => text ? moment(text).format('DD MMMM YYYY') : 'N/A',
    },
    {
        title: 'Purchase Order',
        dataIndex: 'purchaseOrder',
        key: 'purchaseOrder',
        render: (orders) => 
            orders && orders.length > 0 ? orders.join(', ') : 'N/A',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text) => <StatusTag status={text || 'Active'} />,
    },
]
